import * as yup from "yup";

export default yup.object().shape({
  name: yup.string().required("É necessário informar a razão social."),
  cnpj: yup
    .string()
    .required("É necessário informar o CNPJ.")
    .length(14, "O CNPJ deve ter 14 caracteres."),
});
